fragment DocumentCustomer on Customer {
  id
  publicId
  encodedPublicId
  planId
  email
  firstName
  lastName
  companyName
  scanCenter
  returnsAll
  createdAt
  updatedAt
}
